export enum ProfileTypes {
  MAIN = 'main',
  MAIN_WITH_WARNING = 'main_warning',
  ADDITIONAL = 'additional',
  ADDITIONAL_WITH_FULL_ADDRESS_LOCATION = 'additional_with_full_address_location',
}

export enum ProfileViewAttr {
  ADDITIONAL = 'additional_attribute',
}

export enum UserTypes {
  INDIVIDUAL = 'individual',
  ORGANIZATION = 'organization',
  NONE = 'none',
}

export const definedUserTypes: readonly string[] = [UserTypes.INDIVIDUAL, UserTypes.ORGANIZATION];

export type DefinedUserType = (typeof definedUserTypes)[number];

export enum EditProfileParts {
  USER_TYPE = 'userType',
  ROLE = 'role',
  ROLES = 'roles',
  ON_REMOVED_ROLE = 'on_removed_role',
  ON_REMOVED_ROLES = 'on_removed_roles',
}

export enum IndividualRoles {
  patient = 'Patient',
  doctor = 'Doctor',
  med_staff = 'Med Staff',
  researcher = 'Researcher',
  // guardian = 'Guardian'
}

export enum UserType {
  patient = 'Patient',
  doctor = 'Doctor',
  med_staff = 'Med Staff',
  researcher = 'Researcher',
  organization = 'Organization',
}

export enum InitiatorRole {
  patient = 'Patient',
  doctor = 'Doctor',
}

export enum UserRoles {
  patient = 'USER_PATIENT_TITLE',
  doctor = 'USER_DOCTOR_TITLE',
  med_staff = 'USER_MED_STAFF_TITLE',
  researcher = 'USER_RESEARCHER_TITLE',
}

export enum ViewProfileTypes {
  OWNER = 'owner',
  REGULAR = 'regular',
}

export enum CardInfoType {
  string = 'string',
  list = 'list',
  organizationList = 'organization_list',
  creatorLink = 'creator_link',
}

export enum TabTypes {
  communities = 'profile_communities',
  projects = 'profile_projects',
  posts = 'profile_posts',
  connections = 'profile_connections',
  doctor_patients = 'doctor_patients',
}

export const userTypeNameToEnum: (userType: string) => UserType = (userType: string) => {
  switch (userType) {
    case 'Patient':
      return UserType.patient;
    case 'Doctor':
      return UserType.doctor;
    case 'Med Staff':
      return UserType.med_staff;
    case 'Researcher':
      return UserType.researcher;
    case 'Organization':
      return UserType.organization;
    default:
      throw new Error('unknown role');
  }
};
